import React from 'react';
import PropTypes from 'prop-types';

const QaTracker = (props) => {
  const { customClass, tagName, children } = props;
  return (
    <div className={customClass} data-qa={tagName}>
      {children}
    </div>
  );
};


QaTracker.propTypes = {
  tagName: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

QaTracker.defaultProps = {
  customClass: '',
};

export default QaTracker;
